export const baseLimit = 21;

export const getPokeListUrl = `https://pokeapi.co/api/v2/pokemon?limit=${baseLimit}`;
export const getPokeByIdUrl = "https://pokeapi.co/api/v2/pokemon/";
export const getPokeSpeciesUrl = "https://pokeapi.co/api/v2/pokemon-species/";
